import React from 'react';
import { useSearchParams, useNavigate } from 'react-router';

const PaymentFailed = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    
    // URL থেকে এরর মেসেজ নেওয়া (backend redirect থেকে আসে)
    const errorMsg = searchParams.get('msg') || 'Transaction Failed';

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full text-center border border-red-50">
                
                {/* Error Icon */}
                <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M6 18L18 6M6 6l12 12"></path>
                    </svg>
                </div>

                <h1 className="text-2xl font-extrabold text-gray-900 mb-2">Payment Failed</h1>
                <p className="text-gray-500 mb-6">We couldn't process your payment. No money was deducted from your account.</p>

                {/* Error Details */}
                <div className="bg-red-50 border border-red-100 rounded-lg p-4 mb-8 text-sm text-red-700">
                    <span className="font-bold">Reason: </span> 
                    {errorMsg === 'PaymentCancelled' ? 'You cancelled the transaction.' : errorMsg}
                </div>

                {/* Actions */}
                <div className="grid grid-cols-2 gap-4">
                    <button 
                        onClick={() => navigate('/dashboard')}
                        className="w-full bg-gray-100 text-gray-700 font-bold py-3 rounded-xl hover:bg-gray-200 transition"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={() => navigate('/profile')} // যেখানে সাবস্ক্রিপশন কার্ড আছে
                        className="w-full bg-red-600 text-white font-bold py-3 rounded-xl hover:bg-red-700 transition shadow-md"
                    >
                        Try Again
                    </button>
                </div>
                
                <p className="mt-6 text-xs text-gray-400">
                    If you continue facing issues, please contact support at support@DrChamber.com
                </p>
            </div>
        </div>
    );
};

export default PaymentFailed;